webpackJsonp([1],{

/***/ 162:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(216),
  /* template */
  __webpack_require__(266),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 167:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(249)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(203),
  /* template */
  __webpack_require__(264),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 168:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(204),
  /* template */
  __webpack_require__(270),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 169:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(205),
  /* template */
  __webpack_require__(263),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 170:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(206),
  /* template */
  __webpack_require__(257),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 171:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(207),
  /* template */
  __webpack_require__(258),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 172:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(209),
  /* template */
  __webpack_require__(265),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 173:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(210),
  /* template */
  __webpack_require__(269),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 174:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(211),
  /* template */
  __webpack_require__(267),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 175:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(212),
  /* template */
  __webpack_require__(268),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 176:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(213),
  /* template */
  __webpack_require__(261),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 177:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(214),
  /* template */
  __webpack_require__(260),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 178:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(215),
  /* template */
  __webpack_require__(262),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 179:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(217),
  /* template */
  __webpack_require__(259),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 201:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_App__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Team__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Team___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Team__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_BaseHero__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_BaseHero___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_BaseHero__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_BrandBlog__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_BrandBlog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_BrandBlog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_BasePanel__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_BasePanel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_BasePanel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_BaseHeader__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_BaseHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_BaseHeader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_VideoModal__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_VideoModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_VideoModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_ContactForm__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_ContactForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_ContactForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_BrandServices__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_BrandServices___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_BrandServices__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_BrandTimeline__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_BrandTimeline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_BrandTimeline__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_BaseAccordian__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_BaseAccordian___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_BaseAccordian__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_BrandProfiles__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_BrandProfiles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_BrandProfiles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_SearchResults__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_SearchResults___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_SearchResults__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue_smooth_scroll__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue_smooth_scroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_vue_smooth_scroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vue_youtube_embed__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vue_youtube_embed___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_vue_youtube_embed__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_object_fit_images__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_object_fit_images___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_object_fit_images__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_wowjs__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_wowjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_wowjs__);





















__webpack_require__(165);
__webpack_require__(164).polyfill();

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_14_vue_smooth_scroll___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_15_vue_youtube_embed___default.a);

__WEBPACK_IMPORTED_MODULE_16_object_fit_images___default()();

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
    el: '#app',
    components: {
        App: __WEBPACK_IMPORTED_MODULE_1__components_App___default.a,
        Team: __WEBPACK_IMPORTED_MODULE_2__components_Team___default.a,
        BaseHero: __WEBPACK_IMPORTED_MODULE_3__components_BaseHero___default.a,
        BasePanel: __WEBPACK_IMPORTED_MODULE_5__components_BasePanel___default.a,
        BrandBlog: __WEBPACK_IMPORTED_MODULE_4__components_BrandBlog___default.a,
        BaseHeader: __WEBPACK_IMPORTED_MODULE_6__components_BaseHeader___default.a,
        VideoModal: __WEBPACK_IMPORTED_MODULE_7__components_VideoModal___default.a,
        ContactForm: __WEBPACK_IMPORTED_MODULE_8__components_ContactForm___default.a,
        BrandProfiles: __WEBPACK_IMPORTED_MODULE_12__components_BrandProfiles___default.a,
        BrandServices: __WEBPACK_IMPORTED_MODULE_9__components_BrandServices___default.a,
        BrandTimeline: __WEBPACK_IMPORTED_MODULE_10__components_BrandTimeline___default.a,
        BaseAccordian: __WEBPACK_IMPORTED_MODULE_11__components_BaseAccordian___default.a,
        SearchResults: __WEBPACK_IMPORTED_MODULE_13__components_SearchResults___default.a
    }
});

var wow = new __WEBPACK_IMPORTED_MODULE_17_wowjs___default.a.WOW({
    boxClass: 'wow',
    animateClass: 'animated',
    offset: 0,
    mobile: true,
    live: true,
    scrollContainer: null
});

wow.init();

/***/ }),

/***/ 202:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return duration; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return timingFunction; });
var duration = 250;
var timingFunction = 'ease-in-out';

/***/ }),

/***/ 203:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg4everybody__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg4everybody___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg4everybody__);
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'app',
    mounted: function mounted() {
        __WEBPACK_IMPORTED_MODULE_0_svg4everybody___default()();
    }
});

/***/ }),

/***/ 204:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'BaseAccordian',
    props: {
        initialActiveIndex: {
            type: Number
        }
    },
    data: function data() {
        return {
            panels: [],
            activePanel: undefined
        };
    },

    methods: {
        navigate: function navigate(panel) {
            this.activePanel = panel;
        }
    },
    created: function created() {
        var _this = this;

        this.$on('add-panel', function (panel) {
            return _this.panels.push(panel);
        });
        this.$on('set-active-panel', function (panel) {
            _this.activePanel = panel;
        });
    },
    mounted: function mounted() {
        this.activePanel = this.initialActiveIndex === null ? null : this.panels[this.initialActiveIndex];
    }
});

/***/ }),

/***/ 205:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'BaseHeader',
    props: {
        post: {
            type: String
        },
        search: {
            type: String
        },
        site: {
            type: Object,
            required: true
        },
        menus: {
            type: Object,
            required: true
        }
    },
    data: function data() {
        return {
            threshold: 0.1,
            windowWidth: 0,
            showMenu: false,
            showSearch: false,
            rootMargin: '170px',
            headerActive: false
        };
    },

    /* eslint-disable */
    methods: {
        enableScroll: function enableScroll() {
            document.ontouchmove = true;
        },
        preventScroll: function preventScroll() {
            document.ontouchmove = function (event) {
                event.preventDefault();
                event.stopPropagation();
            };
        },
        overflowTrigger: function overflowTrigger(state) {
            return document.documentElement.classList[state]('no-overflow');
        },
        toggleMenuState: function toggleMenuState(menu, showSearch, showMenu) {
            menu === '' + showSearch ? this[showMenu] = false : menu === '' + showMenu ? this[showSearch] = false : menu;
        },
        toggleMenus: function toggleMenus(menu) {
            this[menu] = !this[menu];

            if (this[menu]) {
                // this.preventScroll();
                if (document.documentElement.classList.contains('search--disabled')) {
                    this.showSearch = false;
                } else {
                    this.overflowTrigger('add');
                    this.toggleMenuState(menu, 'showSearch', 'showMenu');
                }
            } else {
                this.enableScroll();
                this.overflowTrigger('remove');
            }
        },
        getWindowWidth: function getWindowWidth() {
            this.windowWidth = document.documentElement.clientWidth;
        },
        intersect: function intersect(entries) {
            var _this = this;

            var entry = entries.filter(function (_ref) {
                var target = _ref.target;

                return target === _this.$refs.header;
            });

            if (entry[0].intersectionRatio < this.threshold) {
                this.headerActive = true;
            } else {
                this.headerActive = false;
            }
        }
    },
    watch: {
        windowWidth: function windowWidth() {
            if (this.windowWidth > 1024) {
                this.showMenu = false;
                this.overflowTrigger('remove');
            }
        },
        showSearch: function showSearch() {
            if (this.showSearch) {
                this.$refs.input.autofocus = true;
            }
        }
    },
    mounted: function mounted() {
        var _this2 = this;

        var io = new IntersectionObserver(this.intersect, {
            rootMargin: this.rootMargin,
            threshold: [this.threshold]
        });

        io.POLL_INTERVAL = 100;
        io.observe(this.$refs.header);

        this.$nextTick(function () {
            window.addEventListener('resize', _this2.getWindowWidth);
            _this2.getWindowWidth();
        });
    },
    beforeDestroy: function beforeDestroy() {
        window.removeEventListener('resize', this.getWindowWidth);
    }
});

/***/ }),

/***/ 206:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'BaseHero',
    data: function data() {
        return {
            activeItem: 0,
            showItem: true,
            windowWidth: 0,
            showContainer: false
        };
    },

    methods: {
        setActiveItem: function setActiveItem(itemIndex) {
            this.activeItem = itemIndex;
            this.showItem = false;
        },
        getWindowWidth: function getWindowWidth() {
            this.windowWidth = document.documentElement.clientWidth;
        }
    },
    mounted: function mounted() {
        var _this = this;

        setTimeout(function () {
            _this.showContainer = true;
        }, 500);

        this.$nextTick(function () {
            window.addEventListener('resize', _this.getWindowWidth);
            _this.getWindowWidth();
        });
    },
    beforeDestroy: function beforeDestroy() {
        window.removeEventListener('resize', this.getWindowWidth);
    }
});

/***/ }),

/***/ 207:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_TransitionPanel__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_TransitionPanel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_TransitionPanel__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'BasePanel',
    components: {
        TransitionPanel: __WEBPACK_IMPORTED_MODULE_0__components_TransitionPanel___default.a
    },
    props: {
        active: {
            type: Boolean,
            default: false
        },
        content: {
            type: String,
            required: true
        }
    },
    data: function data() {
        return {
            isActive: undefined,
            accordion: undefined
        };
    },

    computed: {
        open: function open() {
            return this.accordion ? this === this.accordion.activePanel : this.isActive;
        }
    },
    methods: {
        toggle: function toggle() {
            if (this.accordion) {
                this.accordion.$emit('set-active-panel', this.open ? null : this);
            } else {
                this.isActive = !this.isActive;
            }
        },
        spliceContent: function spliceContent(content) {
            var splicedContent = content.split('.')[0];
            return splicedContent + '.';
        },
        joinContent: function joinContent(content) {
            var joinedContent = content;
            return joinedContent.split('.').slice(1, content.length).join('.');
        }
    },
    created: function created() {
        var parent = this.$parent;

        while (parent) {
            if (parent.$options.name === 'BaseAccordian') {
                parent.$emit('add-panel', this);
                this.accordion = parent;
                this.isActive = null;

                return;
            }

            parent = parent.$parent;
        }

        this.accordion = null;
        this.isActive = this.active;
    }
});

/***/ }),

/***/ 208:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_TransitionPanel__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_TransitionPanel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_TransitionPanel__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'BaseReveal',
    components: {
        TransitionPanel: __WEBPACK_IMPORTED_MODULE_0__components_TransitionPanel___default.a
    },
    props: {
        baseCopy: {
            type: String,
            required: true
        }
    },
    data: function data() {
        return {
            baseReveal: false
        };
    },

    methods: {
        toggleCopy: function toggleCopy() {
            this.baseReveal = !this.baseReveal;
        },
        spliceContent: function spliceContent(content) {
            var splicedContent = content.split('.')[0];
            return splicedContent + '.';
        },
        joinContent: function joinContent(content) {
            var joinedContent = content;
            return joinedContent.split('.').slice(1).join('.');
        }
    }
});

/***/ }),

/***/ 209:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_he__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_he___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_he__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'BrandBlog',
    props: {
        buttonText: {
            type: String,
            required: true
        },
        initialPosts: {
            type: Array,
            required: true
        },
        categories: {
            type: Array,
            required: true
        },
        featuredPosts: {
            type: Array
        }
    },
    data: function data() {
        return {
            currentPage: 1,
            posts: this.initialPosts,
            currentCategory: undefined,
            previousCategory: undefined,
            categoryFilterOpen: false,
            hasLoadedMore: false,
            showLoadMore: true,
            isSticky: false
        };
    },

    computed: {
        categoryIDs: function categoryIDs() {
            var IDList = [];
            this.categories.forEach(function (category) {
                IDList.push(category.ID);
            });
            return IDList;
        },
        currentCategoryName: function currentCategoryName() {
            if (!this.currentCategory) {
                return null;
            }

            if (this.currentCategory instanceof Array) {
                return 'All Posts';
            }

            var categories = this.categories,
                currentCategory = this.currentCategory;
            var length = categories.length;


            for (var index = 0; index < length; index += 1) {
                var category = categories[index];

                if (category.ID === currentCategory) {
                    return category.name;
                }
            }

            return null;
        }
    },
    /* eslint-disable */
    methods: {
        intersect: function intersect(entries) {
            var _this = this;

            var entry = entries.filter(function (_ref) {
                var target = _ref.target;

                return target === _this.$refs.featuredPost;
            });

            if (entry[0].intersectionRatio < 0.1) {
                this.isSticky = true;
            } else {
                this.isSticky = false;
            }
        },
        decode: function decode(str) {
            return __WEBPACK_IMPORTED_MODULE_1_he___default.a.decode(str);
        },
        spliceContent: function spliceContent(postContent) {
            var spliced = postContent;
            if (postContent) {
                return spliced.split(' ').splice(0, 50).join(' ').concat('...');
            }
        },
        getPosts: function getPosts(resetPageCount) {
            var _this2 = this;

            if (!this.hasLoadedMore) {
                this.hasLoadedMore = true;
            }

            if (resetPageCount === true) {
                this.currentPage = 1;
                this.showLoadMore = true;
            } else {
                this.currentPage += 1;
            }

            __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('/wp-json/wp/v2/blog', {
                params: {
                    page: this.currentPage,
                    per_page: 12,
                    categories: this.currentCategory.toString()
                }
            }).then(function (response) {
                if (resetPageCount) {
                    _this2.posts = response.data;
                } else {
                    var _posts;

                    (_posts = _this2.posts).push.apply(_posts, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(response.data));
                }

                if (response.data.length < 12) {
                    _this2.showLoadMore = false;
                }
            }).catch(function (error) {
                _this2.showLoadMore = false;
            });
        },
        getCategoryNames: function getCategoryNames(categories) {
            var _this3 = this;

            if (categories) {
                var categoryNameList = [];
                categories.forEach(function (currentCategory) {
                    _this3.categories.forEach(function (category) {
                        if (currentCategory === category.ID) {
                            categoryNameList.push(_this3.decode(category.name));
                        }
                    });
                });

                return categoryNameList.join(', ');
            }

            return null;
        },
        convertDate: function convertDate(date) {
            return __WEBPACK_IMPORTED_MODULE_3_moment___default()(date, 'YYYYMMDD').format('LL');
        },
        selectAllCategories: function selectAllCategories() {
            this.currentCategory = this.categoryIDs;
            this.categoryFilterOpen = false;

            this.getPosts(true);
        },
        selectCategory: function selectCategory(_ref2) {
            var id = _ref2.id;

            this.currentCategory = id;
            this.categoryFilterOpen = false;

            this.getPosts(true);
        },
        handleStickyPost: function handleStickyPost(container, articleHeight, headerHeight) {
            Array.prototype.forEach.call(container, function (el, index) {
                addEventListener('scroll', function () {
                    var containerElement = el.getBoundingClientRect();
                    if (containerElement.height + containerElement.top - articleHeight[index].getBoundingClientRect().height < headerHeight) {
                        el.classList.remove('sticky');
                        el.classList.add('postStatic');
                    } else if (containerElement.top < headerHeight) {
                        el.classList.remove('postStatic');
                        el.classList.add('sticky');
                    } else {
                        el.classList.remove('sticky');
                        el.classList.remove('postStatic');
                    }
                });
            });
        }
    },
    created: function created() {
        this.currentCategory = this.categoryIDs;
        this.previousCategory = this.categoryIDs;
    },
    mounted: function mounted() {
        var _this4 = this;

        if (this.initialPosts.length < 12) {
            this.showLoadMore = false;
        };

        addEventListener('click', function () {
            _this4.categoryFilterOpen = false;
        });

        var headerHeight = 67;
        var postsContainer = document.querySelectorAll('.blog__posts-container');
        var articleContainer = document.querySelectorAll('.featured-article');

        this.handleStickyPost(postsContainer, articleContainer, headerHeight);
    }
});

/***/ }),

/***/ 210:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'BrandProfiles',
    props: {
        profiles: {
            type: Array,
            required: true
        },
        themeLink: {
            type: String,
            required: true
        }
    },
    data: function data() {
        return {
            windowWidth: 0,
            modalActive: false,
            showItem: null,
            nextActive: false,
            previousActive: false,
            currentProfile: undefined,
            currentProfileIndex: undefined
        };
    },

    /* eslint-disable */
    computed: {
        profilesSorted: function profilesSorted() {
            return this.profiles.sort(this.sortByYear);
        }
    },
    methods: {
        intersect: function intersect(entries) {
            var _this = this;

            var entry = entries.filter(function (_ref) {
                var target = _ref.target;

                return target === _this.$refs.profiles;
            });

            if (entry[0].intersectionRatio) {
                this.showItem = true;
                return;
            }

            this.showItem = false;
        },
        getWindowWidth: function getWindowWidth() {
            this.windowWidth = document.documentElement.clientWidth;
        },
        addComma: function addComma(str) {
            return str ? str.concat(',') : str;
        },
        spliceContent: function spliceContent(profileDescription) {
            var spliced = profileDescription;
            return spliced.split(' ').splice(0, 20).join(' ').concat('...');
        },
        sortByYear: function sortByYear(a, b) {
            if (a.year < b.year) {
                return 1;
            }
            if (a.year > b.year) {
                return -1;
            }

            return 0;
        },
        toggleClass: function toggleClass(state, toggledClass) {
            return document.documentElement.classList[state](toggledClass);
        },
        scrollTo: function scrollTo(x) {
            return this.$refs.modal.scrollTop = x;
        },
        activateModal: function activateModal(profile) {
            this.showItem = false;
            this.currentProfile = profile;
            this.modalActive = !this.modalActive;

            if (this.modalActive) {
                this.toggleClass('add', 'no-overflow');
                this.toggleClass('add', 'brand-profiles--modal-active');
            } else {
                this.toggleClass('remove', 'no-overflow');
                this.toggleClass('remove', 'brand-profiles--modal-active');
            }
        },
        incrementProfile: function incrementProfile() {
            this.currentProfile = this.currentProfileIndex < this.profiles.length - 1 ? this.profiles[this.currentProfileIndex + 1] : this.profiles[this.profiles.length - 1];

            this.scrollTo(0);
        },
        decrementProfile: function decrementProfile() {
            this.currentProfile = this.currentProfileIndex > 0 ? this.profiles[this.currentProfileIndex - 1] : this.profiles[0];

            this.scrollTo(0);
        }
    },
    watch: {
        currentProfile: function currentProfile() {
            this.currentProfileIndex = this.profiles.indexOf(this.currentProfile);
        }
    },
    mounted: function mounted() {
        var _this2 = this;

        var io = new IntersectionObserver(this.intersect, {
            threshold: [this.threshold],
            rootmargin: this.rootmargin
        });

        io.POLL_INTERVAL = 100;
        io.observe(this.$refs.profiles);

        this.$nextTick(function () {
            window.addEventListener('resize', _this2.getWindowWidth);
            _this2.getWindowWidth();
        });
    },
    beforeDestroy: function beforeDestroy() {
        window.removeEventListener('resize', this.getWindowWidth);
    }
});

/***/ }),

/***/ 211:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'BrandServices',
    props: {
        delay: {
            type: String,
            required: true
        },
        themeLink: {
            type: String,
            required: true
        },
        options: {
            type: Object,
            required: false
        },
        familyServices: {
            type: Array,
            required: true
        },
        institutionServices: {
            type: Array,
            required: true
        },
        serviceType: {
            type: String
        }
    },
    data: function data() {
        return {
            activeCategory: null,
            lastActiveCategory: null,
            serviceTypesShown: 'all',
            activeServiceIndex: null,
            activeServiceCategory: null
        };
    },

    computed: {
        activeService: function activeService() {
            if (this.activeServiceIndex === null) {
                return null;
            }

            if (this.activeServiceCategory === 'institution') {
                return this.institutionServices[this.activeServiceIndex];
            }

            if (this.activeServiceCategory === 'family') {
                return this.familyServices[this.activeServiceIndex];
            }

            return null;
        }
    },
    methods: {
        depluralizer: function depluralizer(str) {
            return str.slice(str.length - 1) === 's' ? str.slice(0, str.length - 1) : str;
        },
        updateActiveService: function updateActiveService(serviceType) {
            this.activeServiceCategory = serviceType;
            if (this.activeService) {
                history.replaceState({}, document.title, '#' + this.activeService.slug);
            } else {
                history.replaceState({}, document.title, '#');
            }
        },
        handleClickEvent: function handleClickEvent(category, index) {
            this.activeServiceIndex = index;
            this.updateActiveService(category);
            this.activeCategory = null;
        },
        toggleCategory: function toggleCategory(category) {
            this.activeCategory = this.activeCategory ? null : category;
        }
    },
    watch: {
        activeServiceCategory: function activeServiceCategory(newActiveServiceCategory) {
            if (newActiveServiceCategory !== null) {
                this.lastActiveCategory = newActiveServiceCategory;
            }
        }
    },
    mounted: function mounted() {
        var _this = this;

        if (this.serviceType === 'family') {
            this.serviceTypesShown = 'family';
        }

        if (this.serviceType === 'institution') {
            this.serviceTypesShown = 'institution';
        }

        if (window.location.hash.substr(1)) {
            var requestedServiceSlug = window.location.hash.substr(1);

            this.familyServices.forEach(function (service) {
                if (requestedServiceSlug === service.slug) {
                    _this.activeServiceIndex = _this.familyServices.indexOf(service);
                    _this.activeServiceCategory = 'family';
                }
            });

            this.institutionServices.forEach(function (service) {
                if (requestedServiceSlug === service.slug) {
                    _this.activeServiceIndex = _this.institutionServices.indexOf(service);
                    _this.activeServiceCategory = 'institution';
                }
            });
        }

        addEventListener('click', function () {
            _this.activeCategory = null;
        });
    }
});

/***/ }),

/***/ 212:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'BrandTimeline',
    props: {
        events: {
            type: Array,
            required: true
        },
        breakpoint: {
            type: Number,
            required: true
        }
    },
    data: function data() {
        return {
            threshold: 0.5,
            windowWidth: 0,
            intervalId: null,
            rootmargin: '-50px',
            activeEvent: null,
            timelineActive: false
        };
    },

    /* eslint-disable */
    computed: {
        eventsStyles: function eventsStyles() {
            if (this.windowWidth < this.breakpoint) {
                return {};
            }

            return {
                width: this.events.length * 440 + 'px',
                transform: 'translate(' + this.events.indexOf(this.activeEvent) * -440 + 'px, 0px)'
            };
        },
        eventsSorted: function eventsSorted() {
            return this.events.sort(this.sortByYear);
        }
    },
    methods: {
        nextEvent: function nextEvent() {
            var activeEventIndex = this.events.indexOf(this.activeEvent);

            if (this.timelineActive) {
                this.activeEvent = activeEventIndex < this.events.length - 1 ? this.events[activeEventIndex + 1] : this.activeEvent = this.events[0];
            }
        },
        intersect: function intersect(entries) {
            var _this = this;

            var entry = entries.filter(function (_ref) {
                var target = _ref.target;

                return target === _this.$refs.timeline;
            });

            if (entry[0].intersectionRatio > this.threshold && this.windowWidth > this.breakpoint) {
                this.timelineActive = true;
                this.intervalId = setInterval(this.nextEvent, 3000);
                return;
            }

            this.timelineActive = false;
            clearInterval(this.intervalId);
        },
        getWindowWidth: function getWindowWidth() {
            this.windowWidth = document.documentElement.clientWidth;
        },
        sortByYear: function sortByYear(a, b) {
            if (a.year < b.year) {
                return 1;
            }

            if (a.year > b.year) {
                return -1;
            }

            return 0;
        }
    },
    mounted: function mounted() {
        var _this2 = this;

        this.activeEvent = this.events[0];

        var io = new IntersectionObserver(this.intersect, {
            threshold: [0.5]
        });

        io.POLL_INTERVAL = 100;
        io.observe(this.$refs.timeline);

        this.$nextTick(function () {
            window.addEventListener('resize', _this2.getWindowWidth);
            _this2.getWindowWidth();
        });
    },
    beforeDestroy: function beforeDestroy() {
        window.removeEventListener('resize', this.getWindowWidth);
    }
});

/***/ }),

/***/ 213:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'contact-form',
    props: {
        options: {
            type: Object,
            required: true
        }
    },
    data: function data() {
        return {
            success: null,
            notValid: null,
            formFeilds: {
                email: undefined,
                message: undefined,
                lastName: undefined,
                firstName: undefined,
                phoneNumber: undefined
            }
        };
    },

    methods: {
        submit: function submit() {
            var _this = this;

            if (!this.$refs.form.checkValidity()) {
                this.notValid = true;
                return;
            }

            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post('/wp-admin/admin-ajax.php', new FormData(this.$refs.form)).then(function () {
                _this.resetForm('success', 'notValid');
            }, function () {
                _this.success = false;
            });
        },
        resetForm: function resetForm(successful, unsuccessful) {
            this[successful] = true;
            this[unsuccessful] = false;

            if (this[successful]) {
                var self = this;
                __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.formFeilds).forEach(function (key) {
                    self.formFeilds[key] = '';
                });
            }
        }
    }
});

/***/ }),

/***/ 214:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_he__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_he___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_he__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'SearchResults',
    props: {
        query: {
            type: String,
            required: true
        }
    },
    data: function data() {
        return {
            results: [],
            page: 1,
            removeSearch: false,
            postsRemaining: false,
            searchResults: false
        };
    },

    methods: {
        decode: function decode(string) {
            return __WEBPACK_IMPORTED_MODULE_0_he___default.a.decode(string);
        },
        spliceContent: function spliceContent(searchContent) {
            var spliced = searchContent;
            return spliced.split(' ').splice(0, 20).join(' ').concat('...');
        },
        disableSearchIcon: function disableSearchIcon(state) {
            return document.documentElement.classList[state]('search--disabled');
        },
        getPosts: function getPosts() {
            var _this = this;

            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('/wp-json/wp/v2/search/' + this.query, {
                params: {
                    page: this.page,
                    per_page: 5
                }
            }).then(function (response) {
                if (response.status === 200) {
                    _this.disableSearchIcon('add');
                    _this.results = _this.results.concat(response.data);
                } else {
                    _this.disableSearchIcon('remove');
                    _this.results = [0];
                }

                if (response.data.length > 5) {
                    _this.postsRemaining = true;
                } else {
                    _this.postsRemaining = false;
                }

                if (_this.query === '' && _this.query === undefined) {
                    _this.results = [0];
                }
            });

            this.page += 1;
        }
    },
    watch: {
        results: function results() {
            if (this.results.length === 0) {
                this.searchResults = true;
            } else {
                this.searchResults = false;
            }
        }
    },
    created: function created() {
        this.getPosts();
    }
});

/***/ }),

/***/ 215:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_BaseReveal__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_BaseReveal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_BaseReveal__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'team',
    components: {
        BaseReveal: __WEBPACK_IMPORTED_MODULE_0__components_BaseReveal___default.a
    },
    props: {
        teamMembers: {
            type: Array,
            required: true
        },
        optionText: {
            type: String,
            required: true
        },
        buttonTextPrimary: {
            type: String,
            required: true
        },
        buttonTextSecondary: {
            type: String,
            required: true
        }
    },
    data: function data() {
        return {
            windowWidth: 0,
            showItem: true,
            teamMemberIndex: 0,
            showTeamMember: false,
            activeTeamMember: undefined
        };
    },

    /* eslint-disable */
    computed: {
        filteredTeamMember: function filteredTeamMember() {
            var _this = this;

            var self = this;
            return this.teamMembers.filter(function (teamMember) {
                var foundTeamMember = teamMember.post_title.toLowerCase().indexOf(self.activeTeamMember.toLowerCase()) > -1;

                if (foundTeamMember) {
                    _this.teamMemberIndex = _this.teamMembers.indexOf(teamMember);
                }

                return foundTeamMember;
            });
        }
    },
    methods: {
        getWindowWidth: function getWindowWidth() {
            this.windowWidth = document.documentElement.clientWidth;
        },
        windowScroll: function windowScroll(teamMembers) {
            window.scrollTo(0, 170);
            return teamMembers;
        },
        activateTeamMember: function activateTeamMember(currentTeammember) {
            this.showItem = false;
            this.activeTeamMember = currentTeammember.post_title;
        },
        incrementTeamMember: function incrementTeamMember() {
            this.activeTeamMember = this.teamMemberIndex < this.teamMembers.length - 1 ? this.windowScroll(this.teamMembers[this.teamMemberIndex + 1].post_title) : this.teamMembers[this.teamMembers.length - 1].post_title;
        },
        decrementTeamMember: function decrementTeamMember() {
            this.activeTeamMember = this.teamMemberIndex > 0 ? this.windowScroll(this.teamMembers[this.teamMemberIndex - 1].post_title) : this.teamMembers[0].post_title;
        }
    },
    created: function created() {
        this.activeTeamMember = this.teamMembers[0].post_title;
    },
    mounted: function mounted() {
        var _this2 = this;

        this.$nextTick(function () {
            window.addEventListener('resize', _this2.getWindowWidth);
            _this2.getWindowWidth();
        });
    },
    beforeDestroy: function beforeDestroy() {
        window.removeEventListener('resize', this.getWindowWidth);
    }
});

/***/ }),

/***/ 216:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_velocity_animate__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_velocity_animate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_velocity_animate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__js_util_transitions__ = __webpack_require__(202);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'transition-slide',
    methods: {
        beforeEnter: function beforeEnter(el) {
            el.style.setProperty('will-change', 'height');
        },
        enter: function enter(el, complete) {
            __WEBPACK_IMPORTED_MODULE_0_velocity_animate___default()(el, 'slideDown', { easing: __WEBPACK_IMPORTED_MODULE_1__js_util_transitions__["a" /* timingFunction */], duration: __WEBPACK_IMPORTED_MODULE_1__js_util_transitions__["b" /* duration */], complete: complete });
        },
        afterEnter: function afterEnter(el) {
            el.style.removeProperty('will-change');
        },
        beforeLeave: function beforeLeave(el) {
            el.style.setProperty('will-change', 'height');
        },
        leave: function leave(el, complete) {
            __WEBPACK_IMPORTED_MODULE_0_velocity_animate___default()(el, 'slideUp', { duration: __WEBPACK_IMPORTED_MODULE_1__js_util_transitions__["b" /* duration */], easing: __WEBPACK_IMPORTED_MODULE_1__js_util_transitions__["a" /* timingFunction */], complete: complete });
        },
        afterLeave: function afterLeave(el) {
            el.style.removeProperty('will-change');
        }
    }
});

/***/ }),

/***/ 217:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'VideoModal',
    props: {
        video_id: {
            type: String,
            required: true
        }
    },
    data: function data() {
        return {
            modalActive: false
        };
    }
});

/***/ }),

/***/ 249:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 251:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 40,
	"./af.js": 40,
	"./ar": 47,
	"./ar-dz": 41,
	"./ar-dz.js": 41,
	"./ar-kw": 42,
	"./ar-kw.js": 42,
	"./ar-ly": 43,
	"./ar-ly.js": 43,
	"./ar-ma": 44,
	"./ar-ma.js": 44,
	"./ar-sa": 45,
	"./ar-sa.js": 45,
	"./ar-tn": 46,
	"./ar-tn.js": 46,
	"./ar.js": 47,
	"./az": 48,
	"./az.js": 48,
	"./be": 49,
	"./be.js": 49,
	"./bg": 50,
	"./bg.js": 50,
	"./bm": 51,
	"./bm.js": 51,
	"./bn": 52,
	"./bn.js": 52,
	"./bo": 53,
	"./bo.js": 53,
	"./br": 54,
	"./br.js": 54,
	"./bs": 55,
	"./bs.js": 55,
	"./ca": 56,
	"./ca.js": 56,
	"./cs": 57,
	"./cs.js": 57,
	"./cv": 58,
	"./cv.js": 58,
	"./cy": 59,
	"./cy.js": 59,
	"./da": 60,
	"./da.js": 60,
	"./de": 63,
	"./de-at": 61,
	"./de-at.js": 61,
	"./de-ch": 62,
	"./de-ch.js": 62,
	"./de.js": 63,
	"./dv": 64,
	"./dv.js": 64,
	"./el": 65,
	"./el.js": 65,
	"./en-au": 66,
	"./en-au.js": 66,
	"./en-ca": 67,
	"./en-ca.js": 67,
	"./en-gb": 68,
	"./en-gb.js": 68,
	"./en-ie": 69,
	"./en-ie.js": 69,
	"./en-il": 70,
	"./en-il.js": 70,
	"./en-nz": 71,
	"./en-nz.js": 71,
	"./eo": 72,
	"./eo.js": 72,
	"./es": 75,
	"./es-do": 73,
	"./es-do.js": 73,
	"./es-us": 74,
	"./es-us.js": 74,
	"./es.js": 75,
	"./et": 76,
	"./et.js": 76,
	"./eu": 77,
	"./eu.js": 77,
	"./fa": 78,
	"./fa.js": 78,
	"./fi": 79,
	"./fi.js": 79,
	"./fo": 80,
	"./fo.js": 80,
	"./fr": 83,
	"./fr-ca": 81,
	"./fr-ca.js": 81,
	"./fr-ch": 82,
	"./fr-ch.js": 82,
	"./fr.js": 83,
	"./fy": 84,
	"./fy.js": 84,
	"./gd": 85,
	"./gd.js": 85,
	"./gl": 86,
	"./gl.js": 86,
	"./gom-latn": 87,
	"./gom-latn.js": 87,
	"./gu": 88,
	"./gu.js": 88,
	"./he": 89,
	"./he.js": 89,
	"./hi": 90,
	"./hi.js": 90,
	"./hr": 91,
	"./hr.js": 91,
	"./hu": 92,
	"./hu.js": 92,
	"./hy-am": 93,
	"./hy-am.js": 93,
	"./id": 94,
	"./id.js": 94,
	"./is": 95,
	"./is.js": 95,
	"./it": 96,
	"./it.js": 96,
	"./ja": 97,
	"./ja.js": 97,
	"./jv": 98,
	"./jv.js": 98,
	"./ka": 99,
	"./ka.js": 99,
	"./kk": 100,
	"./kk.js": 100,
	"./km": 101,
	"./km.js": 101,
	"./kn": 102,
	"./kn.js": 102,
	"./ko": 103,
	"./ko.js": 103,
	"./ky": 104,
	"./ky.js": 104,
	"./lb": 105,
	"./lb.js": 105,
	"./lo": 106,
	"./lo.js": 106,
	"./lt": 107,
	"./lt.js": 107,
	"./lv": 108,
	"./lv.js": 108,
	"./me": 109,
	"./me.js": 109,
	"./mi": 110,
	"./mi.js": 110,
	"./mk": 111,
	"./mk.js": 111,
	"./ml": 112,
	"./ml.js": 112,
	"./mr": 113,
	"./mr.js": 113,
	"./ms": 115,
	"./ms-my": 114,
	"./ms-my.js": 114,
	"./ms.js": 115,
	"./mt": 116,
	"./mt.js": 116,
	"./my": 117,
	"./my.js": 117,
	"./nb": 118,
	"./nb.js": 118,
	"./ne": 119,
	"./ne.js": 119,
	"./nl": 121,
	"./nl-be": 120,
	"./nl-be.js": 120,
	"./nl.js": 121,
	"./nn": 122,
	"./nn.js": 122,
	"./pa-in": 123,
	"./pa-in.js": 123,
	"./pl": 124,
	"./pl.js": 124,
	"./pt": 126,
	"./pt-br": 125,
	"./pt-br.js": 125,
	"./pt.js": 126,
	"./ro": 127,
	"./ro.js": 127,
	"./ru": 128,
	"./ru.js": 128,
	"./sd": 129,
	"./sd.js": 129,
	"./se": 130,
	"./se.js": 130,
	"./si": 131,
	"./si.js": 131,
	"./sk": 132,
	"./sk.js": 132,
	"./sl": 133,
	"./sl.js": 133,
	"./sq": 134,
	"./sq.js": 134,
	"./sr": 136,
	"./sr-cyrl": 135,
	"./sr-cyrl.js": 135,
	"./sr.js": 136,
	"./ss": 137,
	"./ss.js": 137,
	"./sv": 138,
	"./sv.js": 138,
	"./sw": 139,
	"./sw.js": 139,
	"./ta": 140,
	"./ta.js": 140,
	"./te": 141,
	"./te.js": 141,
	"./tet": 142,
	"./tet.js": 142,
	"./tg": 143,
	"./tg.js": 143,
	"./th": 144,
	"./th.js": 144,
	"./tl-ph": 145,
	"./tl-ph.js": 145,
	"./tlh": 146,
	"./tlh.js": 146,
	"./tr": 147,
	"./tr.js": 147,
	"./tzl": 148,
	"./tzl.js": 148,
	"./tzm": 150,
	"./tzm-latn": 149,
	"./tzm-latn.js": 149,
	"./tzm.js": 150,
	"./ug-cn": 151,
	"./ug-cn.js": 151,
	"./uk": 152,
	"./uk.js": 152,
	"./ur": 153,
	"./ur.js": 153,
	"./uz": 155,
	"./uz-latn": 154,
	"./uz-latn.js": 154,
	"./uz.js": 155,
	"./vi": 156,
	"./vi.js": 156,
	"./x-pseudo": 157,
	"./x-pseudo.js": 157,
	"./yo": 158,
	"./yo.js": 158,
	"./zh-cn": 159,
	"./zh-cn.js": 159,
	"./zh-hk": 160,
	"./zh-hk.js": 160,
	"./zh-tw": 161,
	"./zh-tw.js": 161
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 251;

/***/ }),

/***/ 256:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(208),
  /* template */
  __webpack_require__(271),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 257:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_vm._t("default", null, {
    showItem: _vm.showItem,
    activeItem: _vm.activeItem,
    windowWidth: _vm.windowWidth,
    showContainer: _vm.showContainer,
    setActiveItem: _vm.setActiveItem
  })], 2)
},staticRenderFns: []}

/***/ }),

/***/ 258:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    class: {
      panel_active: _vm.open
    }
  }, [_c('div', {
    staticClass: "brand-strengths__button-wrapper"
  }, [_c('button', {
    staticClass: "brand-strengths__button",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.toggle
    }
  }, [_vm._t("heading"), _vm._v(" "), _c('div', {
    staticClass: "brand_strengths_toggle-container"
  }, [_vm._t("toggle_symbol")], 2)], 2), _vm._v(" "), _c('p', {
    staticClass: "brand-strengths__item-copy",
    domProps: {
      "innerHTML": _vm._s(_vm.spliceContent(_vm.content))
    }
  }), _vm._v(" "), _c('transition-panel', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.open),
      expression: "open"
    }]
  }, [_c('div', {
    staticClass: "brand-strengths__item-copy",
    domProps: {
      "innerHTML": _vm._s(_vm.joinContent(_vm.content))
    }
  })])]), _vm._v(" "), _c('hr', {
    staticClass: "brand-strengths__horizontal-rule"
  })], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 259:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('button', {
    staticClass: "video-modal__button",
    on: {
      "click": function($event) {
        _vm.modalActive = true
      }
    }
  }, [_vm._t("default")], 2), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.modalActive) ? _c('div', {
    staticClass: "video-modal__modal"
  }, [_c('button', {
    staticClass: "video-modal__close",
    on: {
      "click": function($event) {
        _vm.modalActive = false
      }
    }
  }, [_c('svg', {
    staticClass: "video-modal__close-image",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 72.967 66.236"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "36.483",
      "cy": "33.118",
      "r": "25",
      "fill": "none"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "36.483",
      "cy": "33.118",
      "r": "25",
      "fill": "none",
      "stroke": "#fff",
      "stroke-miterlimit": "10",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "29.783",
      "y1": "26.418",
      "x2": "44.283",
      "y2": "40.918",
      "fill": "none",
      "stroke": "#fff",
      "stroke-linecap": "square",
      "stroke-miterlimit": "10",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "29.783",
      "y1": "40.918",
      "x2": "44.283",
      "y2": "26.418",
      "fill": "none",
      "stroke": "#fff",
      "stroke-linecap": "square",
      "stroke-miterlimit": "10",
      "stroke-width": "2"
    }
  })])]), _vm._v(" "), _c('youtube', {
    staticClass: "video-modal__video",
    attrs: {
      "video-id": _vm.video_id,
      "player-vars": {
        autoplay: 1,
        modestbranding: 1,
        showinfo: 0,
        playsinline: 1,
        rel: 0
      }
    }
  })], 1) : _vm._e()])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 260:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "search__results"
  }, [_c('div', {
    staticClass: "search__results-container"
  }, [_c('form', {
    attrs: {
      "method": "get",
      "action": "/"
    }
  }, [_c('label', {
    staticClass: "access-hidden",
    attrs: {
      "for": "search"
    }
  }, [_vm._v("Search")]), _vm._v(" "), _c('input', {
    staticClass: "header__modal-search-input",
    attrs: {
      "id": "search",
      "type": "search",
      "placeholder": "Search",
      "name": "search",
      "autofocus": "",
      "required": ""
    },
    domProps: {
      "value": _vm.query
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "search__results-signifier"
  }, [_vm._v("Search Results:")]), _vm._v(" "), _vm._l((_vm.results), function(result) {
    return _c('article', {
      staticClass: "search__result"
    }, [_c('a', {
      staticClass: "search__result-title",
      attrs: {
        "href": result.link
      },
      domProps: {
        "textContent": _vm._s(_vm.decode(result.title.rendered))
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "search__result-content",
      domProps: {
        "innerHTML": _vm._s(_vm.spliceContent(result.content.rendered))
      }
    }), _vm._v(" "), _c('a', {
      staticClass: "search__result-link",
      attrs: {
        "href": result.link
      },
      domProps: {
        "textContent": _vm._s('Read More')
      }
    }), _vm._v(" "), _c('hr', {
      staticClass: "search-result__hr"
    })])
  }), _vm._v(" "), (_vm.postsRemaining) ? _c('button', {
    staticClass: "search-results__load-more",
    domProps: {
      "textContent": _vm._s('Load More')
    },
    on: {
      "click": _vm.getPosts
    }
  }) : _vm._e(), _vm._v(" "), (_vm.searchResults) ? _c('div', {
    staticClass: "search__result-none",
    domProps: {
      "textContent": _vm._s('No search results.')
    }
  }) : _vm._e()], 2)])
},staticRenderFns: []}

/***/ }),

/***/ 261:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('form', {
    ref: "form",
    staticClass: "contact-form__input-container"
  }, [_c('input', {
    attrs: {
      "type": "hidden",
      "name": "action",
      "value": "contact"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "contact-form__input-section"
  }, [_c('label', {
    staticClass: "access-hidden",
    attrs: {
      "for": "first-name"
    },
    domProps: {
      "textContent": _vm._s('First Name')
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formFeilds.firstName),
      expression: "formFeilds.firstName"
    }],
    staticClass: "contact-form__input contact-form__input_small contact-form__input_small--primary",
    attrs: {
      "name": "first-name",
      "id": "first-name",
      "type": "text",
      "placeholder": "First Name",
      "required": ""
    },
    domProps: {
      "value": (_vm.formFeilds.firstName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formFeilds, "firstName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "access-hidden",
    attrs: {
      "for": "last-name"
    },
    domProps: {
      "textContent": _vm._s('Last Name')
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formFeilds.lastName),
      expression: "formFeilds.lastName"
    }],
    staticClass: "contact-form__input contact-form__input_small contact-form__input_small contact-form__input_small--secondary",
    attrs: {
      "id": "last-name",
      "name": "last-name",
      "type": "text",
      "placeholder": "Last Name",
      "required": ""
    },
    domProps: {
      "value": (_vm.formFeilds.lastName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formFeilds, "lastName", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "access-hidden",
    attrs: {
      "for": "phone-number"
    },
    domProps: {
      "textContent": _vm._s('Phone Number')
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formFeilds.phoneNumber),
      expression: "formFeilds.phoneNumber"
    }],
    staticClass: "contact-form__input contact-form__input_big",
    attrs: {
      "id": "phone-number",
      "name": "phone-number",
      "type": "tel",
      "placeholder": "Phone Number"
    },
    domProps: {
      "value": (_vm.formFeilds.phoneNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formFeilds, "phoneNumber", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "access-hidden",
    attrs: {
      "for": "email"
    },
    domProps: {
      "textContent": _vm._s('Email')
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formFeilds.email),
      expression: "formFeilds.email"
    }],
    staticClass: "contact-form__input contact-form__input_big",
    attrs: {
      "id": "email",
      "name": "email",
      "type": "email",
      "placeholder": "Email Address",
      "required": ""
    },
    domProps: {
      "value": (_vm.formFeilds.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formFeilds, "email", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "access-hidden",
    attrs: {
      "for": "message"
    },
    domProps: {
      "textContent": _vm._s('Message')
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formFeilds.message),
      expression: "formFeilds.message"
    }],
    staticClass: "contact-form__input contact-form__input_big contact-form__input__big-bottom",
    attrs: {
      "id": "message",
      "name": "message",
      "type": "text",
      "placeholder": "Message"
    },
    domProps: {
      "value": (_vm.formFeilds.message)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formFeilds, "message", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "contact-form__button-container"
  }, [(_vm.notValid) ? _c('p', {
    staticClass: "paragraph-01 contact-form__validity-copy",
    domProps: {
      "textContent": _vm._s(_vm.options.form_error)
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.success) ? _c('button', {
    staticClass: "contact-form__submit-btn",
    attrs: {
      "type": "submit",
      "aria-pressed": "false",
      "aria-describedby": "submit-button"
    },
    domProps: {
      "textContent": _vm._s(_vm.options.submit_button_text)
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.submit()
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.success) ? _c('div', {
    staticClass: "contact-form__submitted-container"
  }, [_c('h3', {
    staticClass: "paragraph-01",
    domProps: {
      "textContent": _vm._s(_vm.options.form_submit)
    }
  })]) : _vm._e()])])])
},staticRenderFns: []}

/***/ }),

/***/ 262:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    ref: "team",
    staticClass: "team"
  }, [_c('transition-group', {
    staticClass: "team__members-photo-container-desktop",
    attrs: {
      "name": "teamMember-fade",
      "appear": ""
    }
  }, _vm._l((_vm.teamMembers), function(teamMember, index) {
    return (index === _vm.teamMemberIndex) ? _c('img', {
      key: index,
      staticClass: "team__members-photo",
      attrs: {
        "src": teamMember.image.sizes.xxxlarge,
        "srcset": teamMember.image.sizes.medium + ' 768w, ' + teamMember.image.sizes.large + ' 1024w, ' + teamMember.image.sizes.xlarge + ' 1280w, ' + teamMember.image.sizes.xxlarge + ' 1920w,' + teamMember.image.sizes.xxxlarge + ' 3000w',
        "sizes": "(min-width: 1024px) 330vh, (min-width: 425px) 1000px, 533px",
        "alt": teamMember.image.alt === '' ? 'Photo of ' + teamMember.post_title : teamMember.image.alt
      }
    }) : _vm._e()
  })), _vm._v(" "), _c('div', {
    staticClass: "team__inner wow fadeInUp",
    attrs: {
      "data-wow-delay": "0.5s"
    }
  }, [_c('header', {
    staticClass: "team__heading-content"
  }, [_vm._t("team-heading-mobile"), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activeTeamMember),
      expression: "activeTeamMember"
    }],
    staticClass: "select-dark team__members",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.activeTeamMember = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "aria-label": "select"
    },
    domProps: {
      "textContent": _vm._s(_vm.optionText)
    }
  }), _vm._v(" "), _vm._l((_vm.teamMembers), function(teamMember) {
    return _c('option', {
      key: teamMember.ID,
      domProps: {
        "textContent": _vm._s(teamMember.post_title)
      }
    })
  })], 2)], 2), _vm._v(" "), _c('transition-group', {
    staticClass: "team__members-photo-container",
    attrs: {
      "tag": "div",
      "name": "teamMember-fade",
      "appear": ""
    }
  }, _vm._l((_vm.teamMembers), function(teamMember, index) {
    return (index === _vm.teamMemberIndex) ? _c('img', {
      key: index,
      staticClass: "team__members-photo",
      attrs: {
        "src": teamMember.image.sizes.large,
        "srcset": teamMember.image.sizes.medium + ' 768w, ' + teamMember.image.sizes.large + ' 1024w, ' + teamMember.image.sizes.xlarge + ' 1280w, ' + teamMember.image.sizes.xxlarge + ' 1920w',
        "sizes": "(min-width: 1024px) 330vh, (min-width: 425px) 1000px, 533px",
        "alt": teamMember.image.alt === '' ? 'Photo of ' + teamMember.post_title : teamMember.image.alt
      }
    }) : _vm._e()
  })), _vm._v(" "), _c('div', {
    staticClass: "team__member-container_left",
    class: _vm.showItem ? 'fade-primary' : null,
    attrs: {
      "data-wow-delay": "0.5s"
    }
  }, [_vm._t("team-heading-desktop"), _vm._v(" "), _c('ul', {
    staticClass: "team__member-list"
  }, _vm._l((_vm.teamMembers), function(teamMember, index) {
    return _c('li', {
      key: index,
      staticClass: "team__member-item",
      on: {
        "click": function($event) {
          _vm.activateTeamMember(teamMember)
        }
      }
    }, [_c('button', {
      staticClass: "team__member-item-btn",
      domProps: {
        "textContent": _vm._s(teamMember.post_title)
      }
    })])
  }))], 2), _vm._v(" "), _vm._l((_vm.filteredTeamMember), function(teamMember) {
    return _c('div', {
      key: teamMember.ID,
      staticClass: "team__member-container_right"
    }, [_c('article', {
      staticClass: "team__member-description-container",
      class: _vm.showItem ? 'fade-primary' : null,
      attrs: {
        "data-wow-delay": "0.5s"
      }
    }, [_c('h3', {
      staticClass: "team__member-name",
      domProps: {
        "textContent": _vm._s(teamMember.post_title)
      }
    }), _vm._v(" "), _vm._t("svg"), _vm._v(" "), _c('p', {
      staticClass: "team__member-copy team__member-copy--mobile",
      domProps: {
        "textContent": _vm._s(teamMember.copy)
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "team__member-nav-container"
    }, [_c('button', {
      staticClass: "team__member-previous-button",
      class: _vm.teamMemberIndex === 0 ? 'team__member-previous-button--disabled' : null,
      on: {
        "click": function($event) {
          _vm.decrementTeamMember()
        }
      }
    }, [_vm._t("carrot-svg"), _vm._v(" "), _c('p', {
      staticClass: "team__member-nav-copy",
      domProps: {
        "textContent": _vm._s('Previous')
      }
    })], 2), _vm._v(" "), _c('button', {
      staticClass: "team__member-next-button",
      class: _vm.teamMemberIndex === _vm.teamMembers.length - 1 ? 'team__member-next-button--disabled' : null,
      on: {
        "click": function($event) {
          _vm.incrementTeamMember()
        }
      }
    }, [_c('p', {
      staticClass: "team__member-nav-copy",
      domProps: {
        "textContent": _vm._s('Next')
      }
    }), _vm._v(" "), _vm._t("carrot-svg-rotated")], 2)]), _vm._v(" "), (_vm.windowWidth >= 1024) ? _c("base-reveal", {
      tag: "div",
      attrs: {
        "base-copy": teamMember.copy
      }
    }) : _vm._e()], 2)])
  })], 2)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 263:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    ref: "header",
    staticClass: "header",
    class: [
      _vm.headerActive ? 'header--active' : null,
      _vm.showSearch ? 'header--search-active' : null,
      _vm.showMenu ? 'header--hamburger-active' : null,
      parseInt(this.post) || _vm.search ? 'header--dark' : null ]
  }, [_c('div', {
    staticClass: "header__container-primary"
  }, [_c('a', {
    attrs: {
      "href": _vm.site.url
    }
  }, [_vm._t("brand-svg")], 2), _vm._v(" "), _c('nav', {
    staticClass: "header__navigation-container"
  }, [_c('div', {
    staticClass: "header__secondary-link-container"
  }, _vm._l((_vm.menus.header_secondary.items), function(item) {
    return _c('a', {
      staticClass: "paragraph-02 header__sublink",
      class: item.current ? 'header--current' : null,
      attrs: {
        "href": item.url
      },
      domProps: {
        "textContent": _vm._s(item.name)
      }
    })
  })), _vm._v(" "), _c('div', {
    staticClass: "header__primary-link-container"
  }, [_vm._l((_vm.menus.header_primary.items), function(item) {
    return _c('a', {
      staticClass: "header__link",
      class: item.current ? 'header--current' : null,
      attrs: {
        "href": item.url
      },
      domProps: {
        "textContent": _vm._s(item.name)
      }
    })
  }), _vm._v(" "), _c('button', {
    staticClass: "header__search-svg-container",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.toggleMenus('showSearch')
      }
    }
  }, [_vm._t("search-icon"), _vm._v(" "), (!_vm.showSearch) ? _c('span', {
    staticClass: "access-hidden",
    domProps: {
      "textContent": _vm._s('Search Button')
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showSearch) ? _c('span', {
    staticClass: "access-hidden",
    domProps: {
      "textContent": _vm._s('Close Search')
    }
  }) : _c('span', {
    staticClass: "access-hidden",
    domProps: {
      "textContent": _vm._s('Open Search')
    }
  })], 2), _vm._v(" "), _c('button', {
    staticClass: "header__hamburger-container",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.toggleMenus('showMenu')
      }
    }
  }, [_c('span', {
    staticClass: "header__hamburger-bar-top"
  }), _vm._v(" "), _c('span', {
    staticClass: "header__hamburger-bar-middle"
  }), _vm._v(" "), _c('span', {
    staticClass: "header__hamburger-bar-bottom"
  }), _vm._v(" "), (_vm.showMenu) ? _c('span', {
    staticClass: "access-hidden",
    domProps: {
      "textContent": _vm._s('Close Menu')
    }
  }) : _c('span', {
    staticClass: "access-hidden",
    domProps: {
      "textContent": _vm._s('Open Menu')
    }
  })])], 2)])]), _vm._v(" "), (_vm.headerActive) ? _c('div', {
    staticClass: "header__container-secondary"
  }, [_c('a', {
    attrs: {
      "href": _vm.site.url
    }
  }, [_vm._t("brand-svg-horizontal")], 2), _vm._v(" "), _c('nav', {
    staticClass: "header__navigation-container"
  }, [_c('div', {
    staticClass: "header__primary-link-container"
  }, [_vm._l((_vm.menus.header_primary.items), function(item) {
    return _c('a', {
      staticClass: "header__link",
      class: item.current ? 'header--current' : null,
      attrs: {
        "href": item.url
      },
      domProps: {
        "textContent": _vm._s(item.name)
      }
    })
  }), _vm._v(" "), _c('button', {
    staticClass: "header__search-svg-container",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.toggleMenus('showSearch')
      }
    }
  }, [_vm._t("search-icon-secondary"), _vm._v(" "), (!_vm.showSearch) ? _c('span', {
    staticClass: "access-hidden",
    domProps: {
      "textContent": _vm._s('Search Button')
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showSearch) ? _c('span', {
    staticClass: "access-hidden",
    domProps: {
      "textContent": _vm._s('Close Search')
    }
  }) : _c('span', {
    staticClass: "access-hidden",
    domProps: {
      "textContent": _vm._s('Open Search')
    }
  })], 2), _vm._v(" "), _c('button', {
    staticClass: "header__hamburger-container",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.toggleMenus('showMenu')
      }
    }
  }, [_c('span', {
    staticClass: "header__hamburger-bar-top"
  }), _vm._v(" "), _c('span', {
    staticClass: "header__hamburger-bar-middle"
  }), _vm._v(" "), _c('span', {
    staticClass: "header__hamburger-bar-bottom"
  }), _vm._v(" "), (_vm.showMenu) ? _c('span', {
    staticClass: "access-hidden",
    domProps: {
      "textContent": _vm._s('Close Menu')
    }
  }) : _c('span', {
    staticClass: "access-hidden",
    domProps: {
      "textContent": _vm._s('Open Menu')
    }
  })])], 2)])]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showSearch),
      expression: "showSearch"
    }],
    staticClass: "header__modal"
  }, [_c('div', {
    staticClass: "header__modal-container"
  }, [_c('form', {
    staticClass: "header__modal-search-container",
    attrs: {
      "method": "get",
      "action": "/"
    }
  }, [_c('label', {
    staticClass: "access-hidden",
    attrs: {
      "for": "search"
    },
    domProps: {
      "textContent": _vm._s('Search')
    }
  }), _vm._v(" "), _c('input', {
    ref: "input",
    staticClass: "header__modal-search-input",
    attrs: {
      "id": "search",
      "type": "search",
      "placeholder": "Search",
      "name": "search",
      "required": ""
    }
  })])])]), _vm._v(" "), (_vm.showMenu) ? _c('nav', {
    staticClass: "header__modal"
  }, [_c('div', {
    staticClass: "header__modal-menu-container"
  }, [_c('div', {
    staticClass: "header__modal-menu-inner"
  }, [_c('ul', {
    staticClass: "header__modal-list"
  }, _vm._l((_vm.menus.header_primary.items), function(item) {
    return (_vm.menus.header_primary.items) ? _c('li', {
      staticClass: "header__modal-item"
    }, [_c('a', {
      staticClass: "label-heading-01 header__modal-link",
      class: item.current ? 'header--current' : null,
      attrs: {
        "href": item.url
      },
      domProps: {
        "textContent": _vm._s(item.name)
      }
    })]) : _vm._e()
  })), _vm._v(" "), _c('hr', {
    staticClass: "horizontal-rule-03"
  }), _vm._v(" "), _c('div', {
    staticClass: "header__modal-sublink-container"
  }, _vm._l((_vm.menus.header_secondary.items), function(item) {
    return _c('a', {
      staticClass: "paragraph-02 header__modal-sublink",
      class: item.current ? 'header--current' : null,
      attrs: {
        "href": item.url
      },
      domProps: {
        "textContent": _vm._s(item.name)
      }
    })
  }))])])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),

/***/ 264:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),

/***/ 265:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "blog"
  }, [_c('div', {
    staticClass: "blog__category-filter-container"
  }, [_c('div', {
    staticClass: "blog__category-filter-inner"
  }, [_c('div', {
    staticClass: "blog__category-filter"
  }, [_c('button', {
    staticClass: "blog__category-text",
    domProps: {
      "innerHTML": _vm._s(_vm.currentCategoryName)
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.categoryFilterOpen = !_vm.categoryFilterOpen
      }
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "services__category-buttons"
    }
  }, [(_vm.categoryFilterOpen) ? _c('div', {
    staticClass: "blog__category-buttons"
  }, [_c('button', {
    staticClass: "blog__category-button",
    on: {
      "click": _vm.selectAllCategories
    }
  }, [_vm._v("All Posts")]), _vm._v(" "), _vm._l((_vm.categories), function(category) {
    return _c('button', {
      key: category.ID,
      staticClass: "blog__category-button",
      domProps: {
        "textContent": _vm._s(_vm.decode(category.name))
      },
      on: {
        "click": function($event) {
          _vm.selectCategory(category)
        }
      }
    })
  })], 2) : _vm._e()])], 1)])]), _vm._v(" "), _c('section', {
    staticClass: "blog__posts-container blog__posts-container--primary"
  }, [_c('section', {
    staticClass: "blog__posts"
  }, _vm._l((_vm.posts.slice(0, 5)), function(post, index) {
    return (post.post_preview || post.guid) ? _c('article', {
      staticClass: "blog__post wow fadeInUp",
      style: (_vm.hasLoadedMore ? 'visibility: visible;' : null),
      attrs: {
        "data-wow-delay": index * 0.15 + 's'
      }
    }, [(post.post_date) ? _c('div', {
      staticClass: "blog__post-date",
      domProps: {
        "textContent": _vm._s(_vm.convertDate(post.post_date) + ' / ')
      }
    }) : _vm._e(), _vm._v(" "), (post.date) ? _c('div', {
      staticClass: "blog__post-date",
      domProps: {
        "textContent": _vm._s(_vm.convertDate(post.date) + ' / ')
      }
    }) : _vm._e(), _vm._v(" "), (post.category_list) ? _c('div', {
      staticClass: "blog__post-category",
      domProps: {
        "textContent": _vm._s(_vm.getCategoryNames(post.category_list))
      }
    }) : _vm._e(), _vm._v(" "), (post.categories) ? _c('div', {
      staticClass: "blog__post-category",
      domProps: {
        "textContent": _vm._s(_vm.getCategoryNames(post.categories))
      }
    }) : _vm._e(), _vm._v(" "), (post.post_title) ? _c('a', {
      staticClass: "blog__post-heading",
      attrs: {
        "href": post.slug
      },
      domProps: {
        "textContent": _vm._s(post.post_title)
      }
    }) : _vm._e(), _vm._v(" "), (post.title) ? _c('a', {
      staticClass: "blog__post-heading",
      attrs: {
        "href": post.slug
      },
      domProps: {
        "textContent": _vm._s(_vm.decode(post.title.rendered))
      }
    }) : _vm._e(), _vm._v(" "), (post.post_preview) ? _c('div', {
      staticClass: "blog__post-content",
      domProps: {
        "textContent": _vm._s(_vm.spliceContent(post.post_preview))
      }
    }) : _c('div', {
      staticClass: "blog__post-content",
      domProps: {
        "textContent": _vm._s(_vm.spliceContent(post.acf.post_preview))
      }
    }), _vm._v(" "), (post.slug) ? _c('a', {
      staticClass: "blog__post-link",
      attrs: {
        "href": post.slug
      }
    }, [_vm._v("\n                    Read More\n                ")]) : _vm._e(), _vm._v(" "), _c('hr', {
      staticClass: "blog__post-hr"
    })]) : _vm._e()
  })), _vm._v(" "), _c('div', {
    ref: "featuredPost",
    staticClass: "blog__post blog__post--featured",
    attrs: {
      "data-wow-delay": "0.25s"
    }
  }, [_vm._t("featured-post--primary")], 2)]), _vm._v(" "), _vm._t("default"), _vm._v(" "), _c('section', {
    staticClass: "blog__posts-container blog__posts-container--secondary"
  }, [_c('section', {
    staticClass: "blog__posts blog__posts--secondary"
  }, _vm._l((_vm.posts.slice(5)), function(post, index) {
    return (post.post_preview || post.guid) ? _c('article', {
      staticClass: "blog__post wow fadeInUp",
      style: (_vm.hasLoadedMore ? 'visibility: visible;' : null),
      attrs: {
        "data-wow-delay": index * 0.15 + 's'
      }
    }, [(post.post_date) ? _c('div', {
      staticClass: "blog__post-date",
      domProps: {
        "textContent": _vm._s(_vm.convertDate(post.post_date))
      }
    }) : _vm._e(), _vm._v(" "), (post.date) ? _c('div', {
      staticClass: "blog__post-date",
      domProps: {
        "textContent": _vm._s(_vm.convertDate(post.date))
      }
    }) : _vm._e(), _vm._v(" "), (post.category_list) ? _c('div', {
      staticClass: "blog__post-category",
      domProps: {
        "textContent": _vm._s(_vm.getCategoryNames(post.category_list))
      }
    }) : _vm._e(), _vm._v(" "), (post.categories) ? _c('div', {
      staticClass: "blog__post-category",
      domProps: {
        "textContent": _vm._s(_vm.getCategoryNames(post.categories))
      }
    }) : _vm._e(), _vm._v(" "), (post.post_title) ? _c('a', {
      staticClass: "blog__post-heading",
      attrs: {
        "href": post.slug
      },
      domProps: {
        "textContent": _vm._s(post.post_title)
      }
    }) : _vm._e(), _vm._v(" "), (post.title) ? _c('a', {
      staticClass: "blog__post-heading",
      attrs: {
        "href": post.slug
      },
      domProps: {
        "textContent": _vm._s(_vm.decode(post.title.rendered))
      }
    }) : _vm._e(), _vm._v(" "), (post.post_preview) ? _c('div', {
      staticClass: "blog__post-content",
      domProps: {
        "textContent": _vm._s(_vm.spliceContent(post.post_preview))
      }
    }) : _c('div', {
      staticClass: "blog__post-content",
      domProps: {
        "textContent": _vm._s(_vm.spliceContent(post.acf.post_preview))
      }
    }), _vm._v(" "), (post.slug) ? _c('a', {
      staticClass: "blog__post-link",
      attrs: {
        "href": post.slug
      },
      domProps: {
        "textContent": _vm._s('Read More')
      }
    }) : _vm._e(), _vm._v(" "), _c('hr', {
      staticClass: "blog__post-hr"
    })]) : _vm._e()
  })), _vm._v(" "), _c('div', {
    staticClass: "blog__post blog__post-featured_secondary"
  }, [_vm._t("featured-post--secondary")], 2)]), _vm._v(" "), (_vm.showLoadMore) ? _c('div', {
    staticClass: "blog__load-more-container"
  }, [_c('button', {
    staticClass: "blog__load-more",
    domProps: {
      "textContent": _vm._s(_vm.buttonText)
    },
    on: {
      "click": function($event) {
        _vm.getPosts(false)
      }
    }
  })]) : _vm._e()], 2)
},staticRenderFns: []}

/***/ }),

/***/ 266:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "slide"
    },
    on: {
      "before-enter": _vm.beforeEnter,
      "enter": _vm.enter,
      "after-enter": _vm.afterEnter,
      "before-leave": _vm.beforeLeave,
      "leave": _vm.leave,
      "after-leave": _vm.afterLeave
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),

/***/ 267:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "services",
    class: [
      _vm.activeServiceCategory !== null && _vm.activeServiceIndex !== null ? ("services--" + _vm.activeServiceCategory) : null,
      _vm.lastActiveCategory ? (_vm.lastActiveCategory + "-last-active") : null
    ]
  }, [_c('div', {
    staticClass: "services__category-containers"
  }, [_c('div', {
    staticClass: "services__category-container service__category-container--family"
  }, [_vm._t("family_category_background_image"), _vm._v(" "), _c('div', {
    staticClass: "services__category-overlay services__category-overlay--family"
  }), _vm._v(" "), (this.serviceTypesShown === 'all' || this.serviceTypesShown === 'family') ? _c('h1', {
    staticClass: "services__category-title wow fadeInUp",
    attrs: {
      "data-wow-delay": _vm.delay
    },
    domProps: {
      "textContent": _vm._s('Families')
    }
  }) : _vm._e(), _vm._v(" "), (this.serviceTypesShown === 'all' || this.serviceTypesShown === 'family') ? _c('div', {
    staticClass: "services__subheading-container"
  }, [_vm._t("brand-services-families-subheading"), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activeServiceIndex),
      expression: "activeServiceIndex"
    }],
    staticClass: "services__category-select-container select-light wow fadeInUp",
    attrs: {
      "data-wow-delay": _vm.delay
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.activeServiceIndex = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.updateActiveService('family')
      }]
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }), _vm._v(" "), _vm._l((_vm.familyServices), function(service, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": index,
        "textContent": _vm._s(service.post_title)
      }
    })
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "services__category-button-container select-light wow fadeInUp"
  }, [_c('button', {
    staticClass: "services__category-text",
    domProps: {
      "innerHTML": _vm._s(_vm.activeService ? _vm.activeService.post_title : '&nbsp;')
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.toggleCategory('family')
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "services__category-spacer"
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "services__category-buttons"
    }
  }, [(_vm.activeCategory === 'family') ? _c('div', _vm._l((_vm.familyServices), function(service, index) {
    return _c('button', {
      key: index,
      staticClass: "services__category-button",
      domProps: {
        "textContent": _vm._s(service.post_title)
      },
      on: {
        "click": function($event) {
          _vm.handleClickEvent('family', index)
        }
      }
    })
  })) : _vm._e()])], 1)], 2) : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "services__category-container service__category-container--institution"
  }, [_vm._t("institution_category_background_image"), _vm._v(" "), _c('div', {
    staticClass: "services__category-overlay services__category-overlay--institution"
  }), _vm._v(" "), (this.serviceTypesShown === 'all' || this.serviceTypesShown === 'institution') ? _c('h1', {
    staticClass: "services__category-title wow fadeInUp",
    attrs: {
      "data-wow-delay": _vm.delay
    },
    domProps: {
      "textContent": _vm._s('Institutions')
    }
  }) : _vm._e(), _vm._v(" "), (this.serviceTypesShown === 'all' || this.serviceTypesShown === 'institution') ? _c('div', {
    staticClass: "services__subheading-container"
  }, [_vm._t("brand-services-institutions-subheading"), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activeServiceIndex),
      expression: "activeServiceIndex"
    }],
    staticClass: "services__category-select-container select-light wow fadeInUp",
    attrs: {
      "data-wow-delay": _vm.delay
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.activeServiceIndex = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.updateActiveService('institution')
      }]
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }), _vm._v(" "), _vm._l((_vm.institutionServices), function(service, index) {
    return _c('option', {
      domProps: {
        "value": index,
        "textContent": _vm._s(service.post_title)
      }
    })
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "services__category-button-container select-light wow fadeInUp"
  }, [_c('button', {
    staticClass: "services__category-text",
    domProps: {
      "innerHTML": _vm._s(_vm.activeService ? _vm.activeService.post_title : '&nbsp;')
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.toggleCategory('institution')
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "services__category-spacer"
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "services__category-buttons"
    }
  }, [(_vm.activeCategory === 'institution') ? _c('div', _vm._l((_vm.institutionServices), function(service, index) {
    return _c('button', {
      key: index,
      staticClass: "services__category-button",
      domProps: {
        "textContent": _vm._s(service.post_title)
      },
      on: {
        "click": function($event) {
          _vm.handleClickEvent('institution', index)
        }
      }
    })
  })) : _vm._e()])], 1)], 2) : _vm._e()], 2)]), _vm._v(" "), _c('article', {
    staticClass: "service",
    class: _vm.activeService ? 'service--active' : null
  }, [_c('button', {
    staticClass: "service__modal-close",
    on: {
      "click": function($event) {
        _vm.activeServiceIndex = null
      }
    }
  }, [_c('svg', {
    attrs: {
      "viewBox": "0 0 23.213 23.213",
      "aria-hidden": "true"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": _vm.themeLink + '/static/graphics/modal-close.svg#modal-close'
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "service__container"
  }, [_c('div', [(_vm.activeService) ? _c('h3', {
    staticClass: "service__subheading",
    domProps: {
      "textContent": _vm._s(_vm.activeService.post_title)
    }
  }) : _vm._e()]), _vm._v(" "), (_vm.activeService) ? _c('div', {
    staticClass: "service__heading",
    domProps: {
      "textContent": _vm._s(_vm.activeService.header)
    }
  }) : _vm._e(), _vm._v(" "), _c('svg', {
    staticClass: "service__svg-group service__svg-group--top",
    attrs: {
      "viewBox": "0 0 96.5 27.042",
      "aria-hidden": "true"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": _vm.themeLink + '/dist/static/graphics/spiral-group.svg#spiral-group'
    }
  })]), _vm._v(" "), (_vm.activeService) ? _c('div', {
    staticClass: "service__content",
    domProps: {
      "textContent": _vm._s(_vm.activeService.copy)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.activeService) ? _c('h2', {
    staticClass: "service__heading service__heading--small",
    domProps: {
      "textContent": _vm._s(_vm.options.contact_header)
    }
  }) : _vm._e(), _vm._v(" "), _c('svg', {
    staticClass: "service__svg-group service__svg-group--bottom",
    attrs: {
      "viewBox": "0 0 96.5 27.042",
      "aria-hidden": "true"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": _vm.themeLink + '/dist/static/graphics/spiral-group.svg#spiral-group'
    }
  })]), _vm._v(" "), (_vm.activeService) ? _c('p', {
    staticClass: "service__content",
    domProps: {
      "textContent": _vm._s(_vm.options.contact_copy)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.activeService) ? _c('a', {
    staticClass: "service__link",
    attrs: {
      "href": _vm.options.contact_link
    },
    domProps: {
      "textContent": _vm._s(_vm.options.contact_link_text)
    }
  }) : _vm._e()])])])
},staticRenderFns: []}

/***/ }),

/***/ 268:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    ref: "timeline",
    staticClass: "timeline",
    class: _vm.windowWidth <= 768 ? 'wow fadeIn' : null,
    attrs: {
      "data-wow-delay": "0.3s"
    }
  }, [_c('header', {
    staticClass: "timeline__intro",
    class: _vm.windowWidth > 768 ? 'wow fadeInRight' : null,
    attrs: {
      "data-wow-delay": "0.3s"
    }
  }, [_c('div', {
    staticClass: "timeline__heading-container"
  }, [_vm._t("heading")], 2), _vm._v(" "), _c('div', {
    staticClass: "timeline__copy-container"
  }, [_vm._t("copy")], 2)]), _vm._v(" "), _c('div', {
    staticClass: "timeline__year-list-container"
  }, [(_vm.events) ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activeEvent),
      expression: "activeEvent"
    }],
    staticClass: "timeline__year-list",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.activeEvent = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.eventsSorted), function(event, index) {
    return _c('option', {
      key: index,
      staticClass: "timeline__year-item",
      class: event === _vm.activeEvent ? 'timeline__year-item--active' : null,
      domProps: {
        "value": event,
        "textContent": _vm._s(event.year)
      }
    })
  })) : _vm._e()]), _vm._v(" "), _c('ul', {
    staticClass: "timeline__year-line-list",
    on: {
      "click": function($event) {
        _vm.timelineActive = false
      }
    }
  }, _vm._l((_vm.eventsSorted), function(event, index) {
    return _c('li', {
      key: index,
      staticClass: "timeline__year-line-item",
      class: event === _vm.activeEvent ? 'timeline__year-line-item--active' : null
    }, [_c('button', {
      staticClass: "timeline__year-line-button",
      domProps: {
        "textContent": _vm._s(event.year)
      },
      on: {
        "click": function($event) {
          _vm.activeEvent = event
        }
      }
    })])
  })), _vm._v(" "), _c('section', {
    staticClass: "timeline__events-container",
    on: {
      "click": function($event) {
        _vm.timelineActive = false
      }
    }
  }, [_c('div', [_c('ul', {
    staticClass: "timeline__events",
    style: (_vm.eventsStyles)
  }, _vm._l((_vm.events), function(event, index) {
    return _c('li', {
      key: index,
      staticClass: "timeline__event",
      class: event === _vm.activeEvent ? 'timeline__event--active' : null,
      on: {
        "click": function($event) {
          _vm.activeEvent = event
        }
      }
    }, [_c('article', {
      staticClass: "timeline__event-content"
    }, [_c('h4', {
      staticClass: "timeline__event-year",
      domProps: {
        "textContent": _vm._s(event.year)
      }
    }), _vm._v(" "), _c('h5', {
      staticClass: "timeline__event-heading",
      domProps: {
        "textContent": _vm._s(event.heading)
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "timeline__event-description",
      domProps: {
        "textContent": _vm._s(event.description)
      }
    })])])
  })), _vm._v(" "), _c('article', {
    staticClass: "timeline__events-reveal"
  }, [_c('div', {
    staticClass: "timeline__events-reveal-container"
  }, [_vm._t("reveal-heading"), _vm._v(" "), _vm._t("reveal-copy"), _vm._v(" "), _vm._t("reveal-button")], 2)])])])])
},staticRenderFns: []}

/***/ }),

/***/ 269:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    ref: "profiles",
    staticClass: "profiles",
    attrs: {
      "id": "brand-profiles"
    }
  }, [_c('div', {
    staticClass: "profiles__container",
    class: _vm.windowWidth <= 768 ? 'wow fadeInUp' : null,
    attrs: {
      "data-wow-delay": "0.5s"
    }
  }, _vm._l((_vm.profilesSorted), function(profile, index) {
    return _c('div', {
      key: profile.ID,
      staticClass: "profile",
      class: _vm.windowWidth > 768 && _vm.showItem ? 'fade-primary' : null,
      attrs: {
        "data-wow-delay": _vm.windowWidth > 768 && _vm.showItem ? index * 0.25 + 's' : null
      }
    }, [_c('div', {
      staticClass: "profile__image-container"
    }, [_c('img', {
      staticClass: "profile__image",
      attrs: {
        "src": profile.image.url,
        "alt": profile.image.alt
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "profile__headings"
    }, [(profile.year) ? _c('h5', {
      staticClass: "label-subheading profile__date",
      domProps: {
        "textContent": _vm._s(profile.year)
      }
    }) : _vm._e(), _vm._v(" "), (profile.post_title) ? _c('h4', {
      staticClass: "heading-05 profile__name",
      domProps: {
        "textContent": _vm._s(profile.post_title)
      }
    }) : _vm._e(), _vm._v(" "), _c('hr', {
      staticClass: "profiles__horizontal-rule"
    })]), _vm._v(" "), (profile.description) ? _c('p', {
      staticClass: "paragraph-02 profile__copy",
      domProps: {
        "textContent": _vm._s(_vm.spliceContent(profile.description))
      }
    }) : _vm._e(), _vm._v(" "), _c('button', {
      staticClass: "paragraph-01 profile__modal-open",
      domProps: {
        "textContent": _vm._s('Learn More')
      },
      on: {
        "click": function($event) {
          _vm.activateModal(profile)
        }
      }
    })])
  })), _vm._v(" "), (_vm.modalActive) ? _c('article', {
    ref: "modal",
    staticClass: "base-modal"
  }, [_c('div', {
    staticClass: "profiles__modal"
  }, [_c('button', {
    staticClass: "profile__modal-close",
    on: {
      "click": function($event) {
        _vm.activateModal()
      }
    }
  }, [_c('svg', {
    attrs: {
      "viewBox": "0 0 23.213 23.213",
      "aria-hidden": "true"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": _vm.themeLink + '/static/graphics/modal-close.svg#modal-close'
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "profile__modal_headings"
  }, [_c('h5', {
    staticClass: "label-subheading profile__date",
    domProps: {
      "textContent": _vm._s(_vm.currentProfile.year)
    }
  }), _vm._v(" "), _c('h4', {
    staticClass: "heading-02 profile__modal-name",
    domProps: {
      "textContent": _vm._s(_vm.currentProfile.post_title)
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "paragraph-01 profile__modal-title"
  }, [_vm._v("\n                    " + _vm._s(_vm.addComma(_vm.currentProfile.award_winners_title)) + "\n                    "), _c('span', {
    staticClass: "paragraph-01 profile__modal-organization"
  }, [_vm._v(_vm._s(_vm.currentProfile.organization))])]), _vm._v(" "), _c('hr', {
    staticClass: "profiles__horizontal-rule"
  })]), _vm._v(" "), _c('div', {
    staticClass: "profile__modal_image-container"
  }, [_c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentProfile.image.url),
      expression: "currentProfile.image.url"
    }],
    staticClass: "profile__image",
    attrs: {
      "src": _vm.currentProfile.image.url,
      "alt": _vm.currentProfile.image.alt === '' ? 'Photo of ' + _vm.currentProfile.post_title : _vm.currentProfile.image.alt
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "profile__modal-copy_container"
  }, [_c('div', {
    staticClass: "paragraph-02 profile__modal_copy",
    domProps: {
      "innerHTML": _vm._s(_vm.currentProfile.description_formatted)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "profile__modal-navigation-container"
  }, [_c('button', {
    staticClass: "profile__modal-previous-button",
    class: _vm.currentProfileIndex === 0 ? 'profile__modal-next-button--disabled' : null,
    on: {
      "click": function($event) {
        _vm.decrementProfile()
      }
    }
  }, [_c('svg', {
    staticClass: "profile__modal-svg",
    attrs: {
      "viewBox": "0 0 8.824 15.147",
      "aria-hidden": "true"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": _vm.themeLink + '/dist/static/graphics/carrot.svg#carrot'
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "profile__modal-navigation-copy",
    domProps: {
      "textContent": _vm._s('Previous')
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "profile__modal-next-button",
    class: _vm.currentProfileIndex === _vm.profiles.length - 1 ? 'profile__modal-previous-button--disabled' : null,
    on: {
      "click": function($event) {
        _vm.incrementProfile()
      }
    }
  }, [_c('p', {
    staticClass: "profile__modal-navigation-copy profile__modal-navigation-secondary",
    domProps: {
      "textContent": _vm._s('Next')
    }
  }), _vm._v(" "), _c('svg', {
    staticClass: "profile__modal-svg profile__modal-svg--rotated",
    attrs: {
      "viewBox": "0 0 8.824 15.147",
      "aria-hidden": "true"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": _vm.themeLink + '/dist/static/graphics/carrot.svg#carrot'
    }
  })])])])])])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),

/***/ 270:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),

/***/ 271:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "team__member-reveal"
  }, [_c('p', {
    staticClass: "team__member-copy team__member-copy--desktop",
    domProps: {
      "textContent": _vm._s(_vm.spliceContent(_vm.baseCopy))
    }
  }), _vm._v(" "), (!_vm.baseReveal) ? _c('button', {
    staticClass: "team__member-cta",
    domProps: {
      "textContent": _vm._s(_vm.$parent.buttonTextPrimary)
    },
    on: {
      "click": function($event) {
        _vm.toggleCopy()
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "team__copy-container"
  }, [_c('transition-panel', [_c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.baseReveal),
      expression: "baseReveal"
    }],
    staticClass: "paragraph-01 team__member-copy",
    domProps: {
      "textContent": _vm._s(_vm.joinContent(_vm.baseCopy))
    }
  })]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.baseReveal),
      expression: "baseReveal"
    }],
    staticClass: "team__member-cta",
    domProps: {
      "textContent": _vm._s(_vm.$parent.buttonTextSecondary)
    },
    on: {
      "click": function($event) {
        _vm.toggleCopy()
      }
    }
  })], 1)])
},staticRenderFns: []}

/***/ })

},[201]);


// WEBPACK FOOTER //
// static/js/app.bf57fcd0e589d0f205b2.js